module.exports = require('./helpers/bundle-url').getBundleURL('1UzNj') + "logo-dark.eefe0b7f.svg";